import type { Milestone } from "./api";

/** Milestone ids ordered by due date ascending — dated first (earliest to
 *  latest), undated last. Ties and undated rows keep their current relative
 *  order (stable). */
export function dueDateOrder(milestones: Milestone[]): string[] {
  return milestones
    .map((m, index) => ({ m, index }))
    .sort((a, b) => {
      if (a.m.due_date && b.m.due_date) {
        return a.m.due_date.localeCompare(b.m.due_date) || a.index - b.index;
      }
      if (a.m.due_date) return -1;
      if (b.m.due_date) return 1;
      return a.index - b.index;
    })
    .map((x) => x.m.id);
}

export interface WeightChange {
  id: string;
  current: number;
  proposed: number;
}

/** Order weight updates so the objective's running weight total never exceeds
 *  100 mid-apply: all decreases first (freeing headroom), then increases,
 *  largest decrease / smallest increase first. The backend re-validates the
 *  sibling sum on every PATCH, so applying an increase before the offsetting
 *  decrease would 422. */
export function weightApplyOrder(changes: WeightChange[]): WeightChange[] {
  const delta = (c: WeightChange) => c.proposed - c.current;
  return changes
    .filter((c) => delta(c) !== 0)
    .sort((a, b) => delta(a) - delta(b));
}
